document.addEventListener("DOMContentLoaded", function () {
  function updateLayout() {
    var width = window.innerWidth;

    if (width >= 768) {
      adjustImageGrid(); // Adjust the image grid when switching to grid layout
    }
  }

  function adjustImageGrid() {
    const gridLayout = document.querySelector(".product-images.grid-layout");
    const images = gridLayout.querySelectorAll(".product-images__slide");
    const imageCount = images.length;

    // Remove previous column span classes
    images.forEach((image) => {
      image.classList.remove("double-column");
    });

    // Apply the necessary column spans based on the number of images
    if (imageCount > 0) {
      images[0].classList.add("double-column"); // First image spans two columns

      if (imageCount % 2 !== 0) {
        images[imageCount - 1].classList.add("double-column"); // Last image spans two columns if odd number of images
        images[imageCount - 2].classList.add("double-column");
      }

      gridLayout.dataset.imagesCount = imageCount; // Add data attribute for special case handling
    }
  }

  window.addEventListener("resize", updateLayout);
  updateLayout();
});

document.addEventListener("DOMContentLoaded", () => {
  // Find the product-images grid-layout container
  const imageContainer = document.querySelector(".product-images.grid-layout");
  const pswpElement = document.querySelector(".pswp");

  if (!imageContainer || !pswpElement) {
    console.log("error did not found fz");
    return;
  }

  // Event listener to handle clicks on the image container
  imageContainer.addEventListener("click", (event) => {
    const clickedImage = event.target.closest("img");

    // Ensure the click is on an image
    if (!clickedImage) return;

    openZoomGallery(imageContainer, pswpElement, clickedImage);
  });

  // Function to open the PhotoSwipe gallery
  function openZoomGallery(container, pswpElement, clickedImage) {
    const items = Array.from(container.querySelectorAll("img")).map((img) => ({
      src: img.getAttribute("src"),
      w: img.naturalWidth || 2048,
      h: img.naturalHeight || 2048,
    }));

    const index = Array.from(container.querySelectorAll("img")).indexOf(
      clickedImage
    );

    const options = {
      index,
      maxSpreadZoom: 2,
      closeOnScroll: false,
      arrowKeys: true,
      history: false,
      getThumbBoundsFn: (index) => {
        const thumbnail = container.querySelectorAll("img")[index];
        const rect = thumbnail.getBoundingClientRect();
        return { x: rect.left, y: rect.top + window.scrollY, w: rect.width };
      },
    };

    if (typeof PhotoSwipe !== "undefined") {
      const pswp = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUI_Default,
        items,
        options
      );

      pswp.listen("beforeChange", () => {
        const activeImage =
          container.querySelectorAll("img")[pswp.getCurrentIndex()];
        activeImage.classList.add("zoomed");
      });

      pswp.listen("close", () => {
        container
          .querySelectorAll("img")
          .forEach((img) => img.classList.remove("zoomed"));
      });

      pswp.init();
    } else {
    }
  }
});
